import React from 'react';
import { BookOpenIcon, ScrollTextIcon } from 'lucide-react';
import { blockChips, mapBlocks } from '../data/content';
const icons = {
  book: BookOpenIcon,
  scroll: ScrollTextIcon
};
export function WhatsIncluded() {
  return <section id="incluye" className="bg-night" data-id="element-236" data-mp="3uax8luklrmvd">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" style={{
      paddingTop: "32px",
      paddingBottom: "25px"
    }} data-id="element-237" data-mp="25tfialto6kf">
        <div className="mx-auto max-w-2xl text-center" data-id="element-238" data-mp="pv5yg26ybszx">
          <h2 className="font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-239" data-mp="ptl2q98wi40h">
            Qué incluye GPS Bíblico
          </h2>
          
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-240" data-mp="gx29evwrce3d">
          {mapBlocks.map(block => {
          const Icon = icons[block.icon];
          return <article key={block.title} className="flex gap-4 rounded-2xl border border-night-line bg-night-panel p-6" data-id="element-241" data-mp="31kp0kvjs6iui">
                <Icon className="mt-1 h-6 w-6 flex-none text-gold-soft" aria-hidden="true" data-id="element-242" data-mp="36kt5dobbtp4w" />
                <div data-id="element-243" data-mp="1wiqjtz2ebq7r">
                  <h3 className="font-display text-xl font-semibold leading-snug text-parchment" data-id="element-244" data-mp="1whxjbfu15wy2">
                    {block.title}
                  </h3>
                  <p className="mt-2 font-sans text-[0.95rem] leading-relaxed text-parchment/70" style={{
                textAlign: "left"
              }} data-id="element-245" data-mp="26gefcr7tt1qz">
                    {block.description}
                  </p>
                </div>
              </article>;
        })}
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-2.5" data-id="element-246" data-mp="2ahgc91e9t1ps">
          {blockChips.map(chip => <li key={chip.label} className="flex items-center gap-2 rounded-full border border-night-line bg-night-panel px-3.5 py-2" data-id="element-247" data-mp="2afm0odow2lyd">
              <span aria-hidden="true" className="h-2 w-2 rounded-full" style={{
            backgroundColor: chip.color
          }} data-id="element-248" data-mp="2k6zymh16zdpe" />
              <span className="font-sans text-sm font-medium text-parchment/85" data-id="element-249" data-mp="2y7kfh7njqzg9">
                {chip.label}
              </span>
              <span className="font-sans text-xs text-parchment/50" data-id="element-250" data-mp="2u3mhx1dvdwpb">{chip.books}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}